import mixitup from "mixitup";

const mixitupContainer = document.querySelector('.activity-overview__container');

if(mixitupContainer) {
    var mixer = mixitup(mixitupContainer, {
        load: {
            filter: ('all')
        },
        selectors: {
            target: '.card-item'
        },
        animation: {
            easing: 'ease-in-out'
        }
    });
}

const yearContainer = document.querySelector('.activity-overview__year__container');
const yearElAll = document.querySelectorAll('.card-item');
const yearButtons = document.querySelectorAll('.year__button')

if (mixitupContainer) {
    
    yearContainer.addEventListener('click', () => {

        yearButtons.forEach((btn) => {
            btn.classList.remove('selected');
        })

        yearElAll.forEach(function (el) {
        const activeClass = el.classList.contains('mixitup-control-active');
            if (activeClass) {
                yearContainer.classList.add('active');
             
                
            }
        });
    });
}
